module.exports = __webpack_public_path__ + "media/images/check-mark-d5bec9f5.png";